export enum AdvFilterValue {
  Any = 'any',
  All = 'all',
  None = 'none',
}
